import { Controller } from "stimulus"
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';

export default class extends Controller {
  static targets = ["content"];

  connect() {
    const keys = JSON.parse(this.data.get("keys"));
    const datasets = JSON.parse(this.data.get("datasets"));
    const color = this.data.get("colors") || "#BBCB44";
    const xAxesType = this.data.get("xaxestype");

    const ctx = this.contentTarget.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 280);
    gradient.addColorStop(0, this.hexToRgba(color, 0.25));
    gradient.addColorStop(1, this.hexToRgba(color, 0.02));

    var xAxes = {
      grid: {
        display: false,
        drawBorder: false,
      },
      ticks: {
        color: '#9A9A8E',
        font: { size: 11, weight: '500' },
        padding: 8,
      }
    }

    if (xAxesType == 'time') {
      xAxes = {
        type: 'time',
        time: { unit: 'month' },
        grid: { display: false, drawBorder: false },
        ticks: {
          maxRotation: 0,
          maxTicksLimit: 4,
          color: '#9A9A8E',
          font: { size: 11 },
        },
      }
    }

    new Chart(this.contentTarget, {
      type: 'line',
      data: {
        labels: keys,
        datasets: [{
          label: '',
          data: datasets,
          backgroundColor: gradient,
          borderColor: color,
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: color,
          pointHoverBorderColor: '#FFFFFF',
          pointHoverBorderWidth: 2,
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index',
        },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#0E1110',
            titleColor: '#DDDDD6',
            bodyColor: '#FFFFFF',
            titleFont: { size: 12, weight: '600' },
            bodyFont: { size: 15, weight: '700', family: "'Inter', system-ui, sans-serif" },
            padding: 12,
            cornerRadius: 8,
            displayColors: false,
            callbacks: {
              label: (ctx) => this.formatAmount(ctx.raw)
            }
          },
        },
        scales: {
          x: xAxes,
          y: {
            border: { display: false },
            grid: {
              color: '#EEEEE8',
              drawBorder: false,
            },
            ticks: {
              maxTicksLimit: 4,
              color: '#9A9A8E',
              font: { size: 11, weight: '500' },
              padding: 8,
              callback: (value) => this.formatAmount(value),
            },
          }
        }
      }
    });
  }

  formatAmount(value) {
    if (value >= 1000000) return (value / 1000000).toFixed(1) + ' M';
    if (value >= 1000) return (value / 1000).toFixed(0) + ' k';
    return value;
  }

  hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
